<template>
  <div class="">
    <sheet>
      <section-title title="居家安胎大小事" />
      <accordion :data="homeUndestandPrevent" />
    </sheet>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { homeUndestandPrevent } from '@/config/accordion';

export default defineComponent({
  name: 'HomeMiscarriagePrevent',
  setup() {
    return {
      homeUndestandPrevent,
    };
  },
});
</script>
<style lang="scss" scoped></style>
